"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation SetOnHold($outputId: String!, $onHoldReason: String!) {\n        setOnHold(outputId: $outputId, onHoldReason: $onHoldReason) {\n            status {\n              name\n            }\n            onHoldDate\n            onHoldReason\n            versions {\n              versionId\n              versionNumber\n              submittedAt\n              dueDate\n              assetId\n              appliedAddons {\n                BURN_IN_CAPTIONS {\n                  value\n                }\n                SRT_CAPTIONS {\n                  value\n                }\n                GREEN_SCREEN {\n                  status\n                }\n                CHROMA_KEY {\n                  status\n                }\n                RUSH_EDIT {\n                  value\n                }\n                DURATION {\n                  value\n                }\n              }\n              requestedAddons {\n                BURN_IN_CAPTIONS {\n                  value\n                }\n                SRT_CAPTIONS {\n                  value\n                }\n                GREEN_SCREEN {\n                  status\n                }\n                CHROMA_KEY {\n                  status\n                }\n                RUSH_EDIT {\n                  value\n                }\n                DURATION {\n                  value\n                }\n              }\n            }    \n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var setOnHoldDateMutation = (0, _graphqlTag.default)(_templateObject());
var setOnHoldDate = {
  mutation: setOnHoldDateMutation,
  module: 'video',
  buildVariables: function buildVariables(_ref) {
    var outputId = _ref.outputId,
        onHoldReason = _ref.onHoldReason;
    return {
      outputId: outputId,
      onHoldReason: onHoldReason
    };
  }
};
var _default = setOnHoldDate;
exports.default = _default;